import { cn } from '../../../utils/mergeClassNames'
import type { NarrativeOcgSeverity } from '../types'

export const getEditorClassName = (
  severity?: NarrativeOcgSeverity,
  isMobile = false
) =>
  cn(
    'narrative-ocg-editor box-border overflow-hidden rounded-[10px] border border-solid border-[#865bdf] bg-white text-[#333] shadow-[0_1px_2px_rgba(0,0,0,0.3),0_2px_6px_2px_rgba(0,0,0,0.15)]',
    isMobile && 'narrative-ocg-editor--mobile shadow-none',
    severity === 'error' && 'narrative-ocg-editor--error border-[#b3261e]',
    severity === 'warning' && 'narrative-ocg-editor--warning border-[#ffa007]'
  )

export const getPanelClassName = (
  severity?: NarrativeOcgSeverity | 'ai' | 'checking'
) =>
  cn(
    'narrative-ocg-panel relative -mx-px -mb-px box-border min-h-[125px] border-x border-b border-solid border-transparent px-5 pb-[18px] pt-2.5 shadow-[0_4px_4px_rgba(0,0,0,0.1)] before:absolute before:left-0 before:top-[9px] before:h-[17px] before:w-0.5 before:bg-current',
    severity !== 'error' && severity !== 'warning' && 'before:hidden',
    severity === 'ai' && 'bg-[#f4f2ff] text-[#865bdf]',
    severity === 'error' && 'border-[#b3261e] bg-[#f5f5f5] text-[#b3261e]',
    severity === 'warning' && 'border-[#ffa007] bg-[#f5f5f5] text-[#ffa007]',
    severity === 'checking' && 'bg-[#f7f7f7] text-[#333]'
  )

export const getActionClassName = (
  variant: 'primary' | 'secondary',
  loading: boolean,
  hasIcon = false
) =>
  cn(
    'narrative-ocg-action inline-flex !h-8 !min-h-0 min-w-[78px] cursor-pointer items-center justify-center whitespace-nowrap rounded-full border border-solid border-transparent !py-0 text-sm font-normal !leading-4 tracking-[0.1px] shadow-none disabled:cursor-not-allowed disabled:opacity-45 max-[640px]:flex-[1_1_calc(50%_-_4px)]',
    loading && 'opacity-75',
    variant === 'secondary' &&
      '!border-[#d9d9d9] !bg-white !px-[17px] !text-[#333]',
    variant === 'primary' &&
      'overflow-hidden !border-0 !bg-[#333] tracking-[0.25px] !text-white hover:!bg-[#333]',
    variant === 'primary' && hasIcon && '!px-[17px]',
    variant === 'primary' && !hasIcon && '!px-3 !pb-0.5'
  )
